import React, { useMemo, useState } from 'react'
import Modal from '../common/Modal'
import SemanticModelsPanel from './SemanticModelsPanel'
import UserRolesPanel from './UserRolesPanel'
import { useAuth } from '../../context/AuthContext'
import {
  MANAGE_USERS_PERMISSION_ID,
  SEMANTICMODELS_MANAGE_PERMISSION_ID,
  hasPermission,
} from '../../constants/permissions'

interface SettingsModalProps {
  isOpen: boolean
  onClose: () => void
}

type Category = 'semantic-models' | 'user-roles'

const SettingsModal: React.FC<SettingsModalProps> = ({ isOpen, onClose }) => {
  const { user } = useAuth()

  const categories = useMemo(() => {
    const list: { id: Category; label: string }[] = []
    if (hasPermission(user?.permissionIds, SEMANTICMODELS_MANAGE_PERMISSION_ID)) {
      list.push({ id: 'semantic-models', label: 'Semantic Models' })
    }
    if (hasPermission(user?.permissionIds, MANAGE_USERS_PERMISSION_ID)) {
      list.push({ id: 'user-roles', label: 'Users & Roles' })
    }
    return list
  }, [user?.permissionIds])

  const [active, setActive] = useState<Category | null>(null)
  const current = active ?? categories[0]?.id ?? null

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Settings" className="settings">
      <div className="settings__layout">
        <nav className="settings__sidebar">
          {categories.map(cat => (
            <button
              key={cat.id}
              className={`settings__category ${
                current === cat.id ? 'settings__category--active' : ''
              }`}
              onClick={() => setActive(cat.id)}
            >
              {cat.label}
            </button>
          ))}
        </nav>
        <div className="settings__panel">
          {current === 'semantic-models' && <SemanticModelsPanel />}
          {current === 'user-roles' && <UserRolesPanel />}
        </div>
      </div>
    </Modal>
  )
}

export default SettingsModal
